export default __webpack_public_path__ + "static/media/coracao.11b2fa12.png";